import { Component, OnInit, Input, OnDestroy } from "@angular/core";
import {
	GlobalDataOpsService,
	GlobalDomOpsService,
	CommonOperationsService
} from "@acepteam/globalspack";
import {
	DataService,
	DomService,
	HelperService,
	LoggerService
} from "../../../../core/services";
import {
	FormBuilder,
	FormGroup,
	Validators,
	AbstractControl
} from "@angular/forms";
import { Address } from "../../../../shared/models";
import { Subscription } from "rxjs";
import { CommonBaseComponent } from "../common-base.component";
import { distinctUntilChanged } from "rxjs/operators";

@Component({
	selector: "app-address",
	templateUrl: "./address.component.html",
	styleUrls: ["./address.component.scss"]
})
export class AddressComponent extends CommonBaseComponent {
	ui_Country = this.dataService.uidata.Countries;
	ui_States = this.dataService.uidata.StateProvinces;

	get country() {
		return this.address.get("country");
	}
	get state() {
		return this.address.get("state");
	}

	@Input() address: FormGroup;

	//VALIDATIONS
	@Input() VALIDATE: boolean = true;

	ngOnInit() {
		//subscriptions
		this.subscriptions.push(
			this.country.valueChanges
				.pipe(distinctUntilChanged())
				.subscribe(country => {
					this.state.setValue("");
					this.refreshStateProvinces(country);
				})
		);

		this.refreshStateProvinces(this.country.value);
		// this.domService.initFlowLabels();
	}

	refreshStateProvinces(countrycode) {
		this.ui_States = this.dataService.uidata.StateProvinces.filter(
			s => s.countrycode === countrycode
		);
		if (this.ui_States.length > 0 && this.VALIDATE) {
			this.state.setValidators([Validators.required]);
		} else {
			this.state.clearValidators();
			this.state.updateValueAndValidity();
		}
	}

	updateValidations(addressFG: AbstractControl) {
		if (addressFG) {
			if (this.VALIDATE) {
				addressFG.get("address2").setValidators(Validators.required);
				addressFG.get("city").setValidators(Validators.required);
				addressFG.get("country").setValidators(Validators.required);
				addressFG.get("state").setValidators(Validators.required);
			} else {
				//NO VALIDATIONS
				addressFG.get("address2").clearValidators();
				addressFG.get("city").clearValidators();
				addressFG.get("country").clearValidators();
				addressFG.get("state").clearValidators();
			}

			addressFG.get("address2").updateValueAndValidity();
			addressFG.get("city").updateValueAndValidity();
			// addressFG.get("country").updateValueAndValidity();
			addressFG.get("state").updateValueAndValidity();
		}
	}

	static buildForm(
		addr: Address,
		fb: FormBuilder,
		validate: boolean = false
	) {
		if (!addr) {
			addr = new Address();
		}
		let fg: FormGroup = fb.group({
			address1: [addr.address1],
			address2: [addr.address2, validate ? Validators.required : []],
			address3: addr.address3,
			city: [addr.city, validate ? Validators.required : []],
			state: [addr.state, validate ? Validators.required : []],
			zip: [addr.zip],
			country: [addr.country, validate ? Validators.required : []]
		});

		return fg;
	}
}
